import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module
import app from './modules/app'
import authentication from './modules/authentication'
import countries from './modules/countries'
import user from './modules/user'
import company from './modules/company'
import subscriptions from './modules/subscriptions'
import payment from './modules/payment'
import invoices from './modules/invoices'
import appSettings from './modules/appSettings'
import locations from './modules/locations'
import appConfigurations from './modules/appConfigurations'
import appSubscriptions from './modules/appSubscriptions'
import appUser from './modules/appUser'
import client from './modules/client'
import dashboard from './modules/dashboard'
import spots from './modules/spots'
import customerCode from './modules/customerCode'
import detection from './modules/detection'
import paymentMethods from './modules/paymentMethods'
import appCurrency from './modules/appCurrency'
import printers from './modules/printers'
import appThirdPartySettings from './modules/appThirdPartySettings'
import errors from './modules/errors'
import content from './modules/content'
import appTranslations from './modules/appTranslations'

import * as getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app,
    authentication,
    countries,
    user,
    company,
    subscriptions,
    payment,
    invoices,
    appSettings,
    locations,
    appConfigurations,
    appSubscriptions,
    appUser,
    client,
    dashboard,
    spots,
    customerCode,
    detection,
    paymentMethods,
    appCurrency,
    printers,
    appThirdPartySettings,
    errors,
    content,
    appTranslations,
  },
  state: {},
  mutations: {},
})

Vue.use(VuexI18n.plugin, store)

export default store
